module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.regions.length > 0) ? _c('div', {
    class: _vm.classes
  }, [(_vm.$breakpoints.smDown) ? _c('sk-dialog', {
    attrs: {
      "light": "",
      "width": "80%",
      "lazy": "",
      "fullscreen": true,
      "overlay": false
    },
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_c('div', {
    staticClass: "dialog__header"
  }, [_c('div', {
    staticClass: "dialog__header-title"
  }, [_c('sk-icon', {
    attrs: {
      "quick-book": ""
    }
  }), _vm._v(" QUICK BOOK")], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.isActive = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleForm($event)
      }
    }
  }), _vm._v(" "), _c('sk-container', [_c('sk-layout', {
    staticClass: "quickbook-form",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('div', {
    staticClass: "form-group quick-book__select"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cinema")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.cinemasByRegion,
      "group-values": "cinemas",
      "group-label": "name",
      "track-by": "name",
      "search": _vm.search,
      "label": "name",
      "searchable": true,
      "placeholder": "Choose A Cinema",
      "multiple": false
    },
    on: {
      "input": function($event) {
        _vm.cinema_selected_here = true
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                                    " + _vm._s(props.option.$groupLabel) + "\n                                ")] : [_c('span', {
          staticClass: "option__title",
          class: {
            'genres': props.option.id
          }
        }, [_vm._v(_vm._s(props.option.name) + " "), (props.option.distance) ? [_vm._v("- " + _vm._s(props.option.distance) + "KM")] : _vm._e()], 2)]]
      }
    }]),
    model: {
      value: (_vm.form_data.selected_cinema),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "selected_cinema", $$v)
      },
      expression: "form_data.selected_cinema"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_vm._v("\n                                No cinema found, try a different cinema\n                            ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Movie / Event")]), _vm._v(" "), (_vm.movies) ? [(_vm.movies.now_showing.length > 0) ? _c('sk-combo-select', {
    attrs: {
      "options": _vm.movies.now_showing,
      "search": _vm.search,
      "searchable": true,
      "placeholder": "Choose A Movie",
      "multiple": false,
      "track-by": "title",
      "label": "title"
    },
    on: {
      "input": function($event) {
        _vm.movie_selected_here = true
      }
    },
    model: {
      value: (_vm.selected_movie),
      callback: function($$v) {
        _vm.selected_movie = $$v
      },
      expression: "selected_movie"
    }
  }) : (!_vm.form_data.selected_cinema) ? _c('div', [_vm._v("No Movies Found")]) : _c('div', [_vm._v("choose a different cinema")])] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Cinema")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__labels"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cinema Type")]), _vm._v(" "), (_vm.selected_movie && _vm.form_data.selected_cinema) ? [_c('sk-list', {
    attrs: {
      "inline": ""
    }
  }, _vm._l((_vm.cinemaExperiences), function(i, index) {
    return _c('sk-list-item', {
      key: index
    }, [_c('span', {
      staticClass: "label",
      class: {
        'label--active': _vm.cinema_type == i
      },
      on: {
        "click": function($event) {
          _vm.selected_cinema_type = i;
        }
      }
    }, [_vm._v(_vm._s(i))])])
  }))] : (!this.selected_movie) ? _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                            Choose A Movie\n                        ")]) : (!_vm.selected_cinema) ? _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                            Choose A Cinema\n                        ")]) : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                            No Performances available\n                        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select quick-book__select--small"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date")]), _vm._v(" "), (_vm.cinema_type && _vm.form_data.selected_cinema && _vm.selected_movie && _vm.sessions) ? [(_vm.availableDates.length > 0) ? [_c('sk-combo-select', {
    attrs: {
      "options": _vm.availableDates,
      "search": _vm.search,
      "label": "string",
      "searchable": false,
      "placeholder": "Date",
      "multiple": false
    },
    model: {
      value: (_vm.selected_date),
      callback: function($$v) {
        _vm.selected_date = $$v
      },
      expression: "selected_date"
    }
  })] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                                Choose A Movie\n                            ")])] : [_c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Cinema Type")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select quick-book__select--small"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Time")]), _vm._v(" "), (_vm.cinema_type && _vm.form_data.selected_cinema && _vm.selected_movie && _vm.selected_date != null) ? [(_vm.selected_date) ? [_c('sk-combo-select', {
    attrs: {
      "options": _vm.availableSessions,
      "search": _vm.search,
      "searchable": false,
      "placeholder": "Time",
      "multiple": false,
      "label": "time"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.time) + " - " + _vm._s(props.option.screen_name))])]
      }
    }]),
    model: {
      value: (_vm.selected_time),
      callback: function($$v) {
        _vm.selected_time = $$v
      },
      expression: "selected_time"
    }
  })] : _vm._e()] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Date")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__btn--book"
  }, [_c('sk-button', {
    attrs: {
      "block": "",
      "disabled": (_vm.canBook && _vm.selected_time != null) ? false : true,
      "primary": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.startOrder()
      }
    }
  }, [_vm._v("\n                            Book now\n                        ")])], 1)])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "quick_book_container",
    staticClass: "quick-book__form"
  }, [_c('sk-container', [_c('div', {
    staticClass: "quick-book__wrap-btn"
  }, [_c('sk-button', {
    staticClass: "quick-book__btn--toggle",
    nativeOn: {
      "click": function($event) {
        _vm.toggleForm($event)
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "quick-book": ""
    }
  }), _vm._v(" QUICK BOOK "), _c('sk-icon', {
    attrs: {
      "up-open": !_vm.isActive,
      "down-open": _vm.isActive
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "quickbook-form",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('div', {
    staticClass: "form-group quick-book__select"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cinema")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.cinemasByRegion,
      "group-values": "cinemas",
      "group-label": "name",
      "track-by": "name",
      "search": _vm.search,
      "label": "name",
      "searchable": true,
      "placeholder": "Choose A Cinema",
      "multiple": false
    },
    on: {
      "input": function($event) {
        _vm.cinema_selected_here = true
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                                " + _vm._s(props.option.$groupLabel) + "\n                            ")] : [_c('span', {
          staticClass: "option__title",
          class: {
            'genres': props.option.id
          }
        }, [_vm._v(_vm._s(props.option.name) + " "), (props.option.distance) ? [_vm._v("- " + _vm._s(props.option.distance) + "KM")] : _vm._e()], 2)]]
      }
    }]),
    model: {
      value: (_vm.form_data.selected_cinema),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "selected_cinema", $$v)
      },
      expression: "form_data.selected_cinema"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_vm._v("\n                            No cinema found, try a different cinema\n                        ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Movie / Event")]), _vm._v(" "), (_vm.movies) ? [(_vm.movies.now_showing.length > 0) ? _c('sk-combo-select', {
    attrs: {
      "options": _vm.movies.now_showing,
      "search": _vm.search,
      "searchable": true,
      "placeholder": "Choose A Movie",
      "multiple": false,
      "track-by": "title",
      "label": "title"
    },
    on: {
      "input": function($event) {
        _vm.movie_selected_here = true
      }
    },
    model: {
      value: (_vm.selected_movie),
      callback: function($$v) {
        _vm.selected_movie = $$v
      },
      expression: "selected_movie"
    }
  }) : (!_vm.form_data.selected_cinema) ? _c('div', [_vm._v("No Movies Found")]) : _c('div', [_vm._v("choose a different cinema")])] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Cinema")])], 2), _vm._v(" "), (_vm.$breakpoints.lg) ? _c('div', {
    staticClass: "form-group quick-book__labels"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cinema Type")]), _vm._v(" "), (_vm.selected_movie && _vm.form_data.selected_cinema) ? [_c('sk-list', {
    attrs: {
      "inline": ""
    }
  }, _vm._l((_vm.cinemaExperiences), function(i, index) {
    return _c('sk-list-item', {
      key: index
    }, [_c('span', {
      staticClass: "label",
      class: {
        'label--active': _vm.cinema_type == i
      },
      on: {
        "click": function($event) {
          _vm.selected_cinema_type = i;
        }
      }
    }, [_vm._v(_vm._s(i))])])
  }))] : (!this.selected_movie) ? _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                        Choose A Movie\n                    ")]) : (!_vm.selected_cinema) ? _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                        Choose A Cinema\n                    ")]) : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                        No Performances available\n                    ")])], 2) : _c('div', {
    staticClass: "form-group quick-book__select"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cinema Type")]), _vm._v(" "), _c('sk-combo-select', {
    attrs: {
      "options": _vm.cinemaExperiences,
      "search": _vm.search,
      "searchable": true,
      "placeholder": "Choose A Cinema Type",
      "multiple": false
    },
    on: {
      "input": function($event) {
        _vm.movie_selected_here = true
      }
    },
    model: {
      value: (_vm.selected_cinema_type),
      callback: function($$v) {
        _vm.selected_cinema_type = $$v
      },
      expression: "selected_cinema_type"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select quick-book__select--small"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Date")]), _vm._v(" "), (_vm.cinema_type && _vm.form_data.selected_cinema && _vm.selected_movie && _vm.sessions) ? [(_vm.availableDates.length > 0) ? [_c('sk-combo-select', {
    attrs: {
      "options": _vm.availableDates,
      "search": _vm.search,
      "label": "string",
      "searchable": false,
      "placeholder": "Date",
      "multiple": false
    },
    model: {
      value: (_vm.selected_date),
      callback: function($$v) {
        _vm.selected_date = $$v
      },
      expression: "selected_date"
    }
  })] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("\n                            Choose A Movie\n                        ")])] : [_c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Date")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__select quick-book__select--smaller"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Time")]), _vm._v(" "), (_vm.cinema_type && _vm.form_data.selected_cinema && _vm.selected_movie && _vm.selected_date != null) ? [(_vm.selected_date) ? [_c('sk-combo-select', {
    attrs: {
      "options": _vm.availableSessions,
      "search": _vm.search,
      "searchable": false,
      "placeholder": "Time",
      "multiple": false,
      "label": "time"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.time) + " - " + _vm._s(props.option.screen_name))])]
      }
    }]),
    model: {
      value: (_vm.selected_time),
      callback: function($$v) {
        _vm.selected_time = $$v
      },
      expression: "selected_time"
    }
  })] : _vm._e()] : _c('div', {
    staticClass: "quick-book__choose"
  }, [_vm._v("Choose a Time")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group quick-book__btn--book"
  }, [_c('sk-button', {
    attrs: {
      "disabled": (_vm.canBook && _vm.selected_time != null) ? false : true,
      "primary": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.startOrder()
      }
    }
  }, [_vm._v("\n                        Book now\n                    ")])], 1)])], 1)], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e32e134","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/quick-book/quick-book.vue
// module id = 749
// module chunks = 0